<template>
  <div class="content-cont">
    <p class="header-title">Delete User Type</p>
    <div class="hint-modal">
      Are you sure you want to "Delete" the user type {{ name }}?
    </div>

    <!-- action btns  -->
    <hr class="h-line" />
    <div class="action-btns">
      <button
        :disabled="isSubmitted"
        @click="$bvModal.hide('deleteUserTypeModal')"
        class="submit-action-btn btn btn-primary"
        size="lg"
      >
        Cancel
      </button>
      <button
        :disabled="isSubmitted"
        @click="onSubmit()"
        class="btn cancel-btn"
        type="button"
      >
        Delete
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      id: null,
      name: null,
      isSubmitted: false,
    };
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
  },
  methods: {
    ...mapActions("userType", ["deleteUserType"]),
    onSubmit() {
      this.isSubmitted = true;
      this.deleteUserType(this.id)
        .then((res) => {
          console.log("res", res);
          this.$emit("updateUserTypeOrDeleted");
          this.$bvModal.hide("deleteUserTypeModal");
        })
        .catch((e) => {
          console.log("e", e);
          this.isSubmitted = false;
        });
    },
  },
  beforeMount() {
    console.log("this.getModalInfo", this.getModalInfo);
    this.id = this.getModalInfo.id;
    this.name = this.getModalInfo.name;
  },
};
</script>

<style>
div#deleteUserTypeModal {
  padding-inline-end: 0px !important;
  border-radius: 26px;

  div#deleteUserTypeModal___BV_modal_content_ {
    width: 579px !important;
    top: 150px;
    border-radius: 26px;
  }
  .modal-content .modal-body {
    p.header-title {
      font-weight: 700;
      font-size: 17px;
      line-height: 20px;
      margin-bottom: 40px;
      color: #000000;
    }
    .hint-modal {
      font-weight: 400;
      font-size: 20px;
      line-height: 24px;
      margin-bottom: 40px;
      text-align: center;
      color: #787878;
    }
    .h-line {
      opacity: 0.15;
      background: #707070;
      width: 488px;
      margin: 0px auto 20px auto;
    }
    .action-btns {
      .submit-action-btn {
        background: #103f5e;
        border-radius: 16.6275px;
        width: 111px;
        height: 33px;
        color: #ffffff;

        display: flex;
        align-items: center;
        justify-content: center;

        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        text-align: center;
        margin-inline-end: 31px;
      }
      .cancel-btn {
        border: 1.5px solid #f46a6a;
        border-radius: 16.6275px;
        color: #f46a6a;

        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        text-align: center;
        width: 111px;
        height: 33px;
      }
    }
  }
}
.cursor-stop {
  cursor: not-allowed;
}
</style>
